import { Component, OnInit, Output, EventEmitter, Renderer2 } from '@angular/core';
import templateString from './optimizationGroupChangeOrder.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString, host: {'forUniqueComponentId': 'aeofijaofiewie'}
})
export class OptimizationGroupChangeOrderComponent implements OnInit {
    @Output() action = new EventEmitter();
    
    public originalOptimizationGroups: any;
    
    public optimizationGroups: any;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2
    ) { 
        this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
    }

    ok() {
        this.http.post("optimization_groups/update_order", { optimization_group_ids: this.optimizationGroups.map(function(x) { return x.id; }) }).subscribe(() => {
            this.action.emit(true);
            this.bsModalRef.hide();
		});
    }

    cancel() {
        this.bsModalRef.hide();
    };

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.optimizationGroups, event.previousIndex, event.currentIndex);
    }

    ngOnInit() {
        this.optimizationGroups = JSON.parse(JSON.stringify(this.originalOptimizationGroups));
    }
}
